module.exports = __webpack_public_path__ + "img/portfolio-02.34610576.jpg";